import React from "react";
import { Avatar } from "@patternfly/react-core";

export default props => {
  const avatarStyle = {
    width: "2.25rem",
    height: "2.25rem",
  };
  return (
    <Avatar src={props.imgAvatar} alt="Avatar image" style={avatarStyle} />
  );
};
